<div class="coupon-container">
  <bkg-coupon
    style="display: flex; justify-content: center"
    *ngFor="let voucher of vouchers"
    [name]="voucher.name"
    [discount]="getVoucherDiscountText(voucher)"
    [expirationDate]="getVoucherExpirationText(voucher.end_date)"
    [isEnabled]="voucher.code === selectedVoucherCode"
    [code]="voucher.code"
    [id]="voucher.id"
    [type]="getCouponType(voucher.scope)"
    (addVoucherCodeReturn)="onCouponSelected($event)"
  ></bkg-coupon>
</div>
